<template>
	<v-container >
		<div >
			<h1 class="mx-auto">Creador de curriculums por</h1>
			<img src="@/assets/logo2.png" width="500">
		</div>	
	</v-container>
</template>
<script>
	export default {
		name: "AcercaDe"
	}
</script>